import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type CheckIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function CheckIcon({
  className,
  pathClassName = "stroke-white",
  ...props
}: CheckIconProps) {
  return (
    <Svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      {...props}
    >
      <Path
        d="M3 7.863l2.814 2.814a1.065 1.065 0 001.515 0L13 5.008"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
    </Svg>
  );
}

export default CheckIcon;
